// components/features/candidatures/CandidatureRow.tsx
import { Candidature } from "../../../types/features/Candidature";
import TableRow from "../../ui/TableRow";

interface CandidatureRowProps {
  candidature: Candidature;
  onAction: (candidature: Candidature) => void;
  onSelect?: (candidature: Candidature, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function CandidatureRow({
  candidature,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false,
}: CandidatureRowProps) {
  const getStatusLabel = () => {
    switch (candidature.status) {
      case "pending":
        return { label: "En attente", className: "bg-yellow-100 text-yellow-700" };
      case "reviewed":
        return { label: "Examinée", className: "bg-blue-100 text-blue-700" };
      case "accepted":
        return { label: "Acceptée", className: "bg-green-100 text-green-700" };
      case "rejected":
        return { label: "Rejetée", className: "bg-red-100 text-red-700" };
      default:
        return { label: "En attente", className: "bg-gray-100 text-gray-700" };
    }
  };

  const status = getStatusLabel();

  return (
    <TableRow
      item={candidature}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div>
          <span className="font-medium text-gray-800 block">{candidature.full_name}</span>
          <span className="text-xs text-gray-500">{candidature.email}</span>
        </div>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <span className="text-gray-600 text-sm">{candidature.phone || "-"}</span>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <span className="text-gray-600 text-sm">{candidature.job_offer?.title || "-"}</span>
      </td>

      <td className="hidden lg:table-cell py-3 px-4">
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${status.className}`}>{status.label}</span>
      </td>
    </TableRow>
  );
}
